module.exports = __webpack_public_path__ + "static/media/dan-1.5c5cbdf0.jpg";